module.exports = "/_next/static/images/customer-review-magdalena@2x-min-96a06f91da148c9e7edf8aba1df55d80.png.webp";